export default {
  isLoggedIn: state =>
    state.user !== null &&
    typeof state.user === 'object' &&
    Object.entries(state.user).length > 0,
}
